(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-focus-produit"] && !Shopify.designMode) return;
  try {
    
if (!window.ccFocusLightboxOnClickBound) {
  window.ccFocusLightboxOnClickBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const image = event.target.closest('.cc-focus__gallery .product-gallery__media img');

      if (!image) {
        return;
      }

      const media = image.closest('.product-gallery__media');
      const gallery = media?.closest('.cc-focus__gallery.product-gallery');

      if (!gallery || !gallery.hasAttribute('allow-zoom')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const imageCells = Array.from(gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]'));
      const index = imageCells.indexOf(media);

      if (index === -1) {
        return;
      }

      gallery.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index } }));
    },
    true,
  );
}

(function () {
  document.querySelectorAll('.cc-focus__gallery').forEach(function (gallery) {
    var carousel = gallery.querySelector('.cc-focus__gallery .product-gallery__carousel');
    if (!carousel || carousel.dataset.ccFocusMobileOrderInitialized) { return; }
    carousel.dataset.ccFocusMobileOrderInitialized = 'true';

    var originalCells = Array.from(carousel.children);
    var mobileOrder = [0, 2, 1, 3];
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function syncGalleryOrder() {
      var cells = mobileQuery.matches
        ? mobileOrder.map(function (index) { return originalCells[index]; }).filter(Boolean)
        : originalCells;

      cells.forEach(function (cell) {
        carousel.appendChild(cell);
      });

      if (carousel.select) {
        carousel.select(0, { instant: true });
      }
    }

    syncGalleryOrder();
    mobileQuery.addEventListener('change', syncGalleryOrder);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
